import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';

export const MODELS = [
  'gemini-2.5-pro',
  'gemini-2.5-flash',
  'gemini-2.5-flash-lite',
  'gemini-2.0-flash',
  'gemini-2.0-flash-exp',
  'gemini-1.5-pro',
  'gemini-1.5-flash',
].map((value) => ({
  label: value,
  value,
}));

export const DEFAULT_MODEL = 'gemini-2.5-flash';

export function useChatGoogleVertexAIModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = kwargs.model ?? DEFAULT_MODEL;

  return {
    model,
    provider: id,
  };
}

export function inferChatGoogleVertexAIManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun> | null
): SerializedConstructor | null {
  if (
    params?.ls_provider !== 'google_vertexai' ||
    !(params?.ls_model_type == null || params.ls_model_type === 'chat')
  ) {
    return null;
  }

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain', 'chat_models', 'vertexai', 'ChatVertexAI'],
    kwargs: {
      ...(params.ls_model_name !== undefined && {
        model: params.ls_model_name,
        model_name: undefined,
      }),
      ...(params.ls_temperature !== undefined && {
        temperature: params.ls_temperature,
      }),
      ...(params.ls_max_tokens !== undefined && {
        max_tokens: params.ls_max_tokens,
        max_output_tokens: undefined,
      }),
      credentials: {
        lc: 1,
        type: 'secret',
        id: ['GOOGLE_VERTEX_AI_WEB_CREDENTIALS'],
      },
      full_model_name: undefined,
    },
  };
}
